import './WorkAtWelleo.css';
import React from 'react';
import joinUsImage from './images/join_us_image.png';
import codePicture from './images/CodePicture.jpg';
import internshipImage from './images/job_posting_header_internship.jpg';
import { Helmet } from 'react-helmet';
import frontendImage from './images/job_posting_header_frontend.png';
import managerImage from './images/job_posting_header_projectman.jpg';
import workload50100 from './images/50-100.png';
import workload2550 from './images/25-50.png';
import Footer from './Footer2';
import logo from "./images/welleo_logo_transp.png";
function WorkAtWelleo() {
    return (
        <div className="WorkAtWelleo">
            <Helmet>
                <title>Careers - Apply Today</title>
                <meta name="description" content="We are currently developing Stafly and are constantly looking for new talent, both junior and experienced. Check out our available positions and apply today."/>
                <link rel="canonical" href="https://staflyapp.com/careers" />
                <meta property="og:image" content={logo} />
                <meta property="og:url" content="https://staflyapp.com/careers" />
                <meta name="twitter:image" content={logo} />
            </Helmet>
            <Body1 />
            <Footer />
        </div>
    );
}
function Body1() {
    const backendLink = 'https://docs.google.com/forms/d/e/1FAIpQLSeyI4Q7p50iMlqzsJgNpPXL6MLznukQu31xgZ30zYpTp7QyGQ/viewform';
    const frontendLink = 'https://docs.google.com/forms/d/1k54FhBNQvk776lkAb-8oxSEQPZFbuP4fdBgVuLasPQY';
    const internshipLink = 'https://docs.google.com/forms/d/1RYHPN4HAr6JSvXehzycVVVXT5uD02RsxQUt3GXHT1DE';
    const technichalLeadLink = 'https://docs.google.com/forms/d/e/1FAIpQLSdFv2Y8EfUw4HxnmsZAKUpSCnmOMFHFfByhmsgPW43DRn5FPQ/viewform';
    return (
        <div className="WorkAtWelleoBody">
            <div className="FirstContainer">
                <div className="WAW-grid-container1">
                    <div className="WAW-grid-item">
                        <div className="WAW-grid-item-text">
                            <h1 className="BolderH3"><span className="colored-text3">WE ARE HIRING</span></h1>
                            <h2 className="BolderP">We are currently developing our platform and app and are looking for both junior and experienced talent. Check out our open positions below and apply today!</h2>
                        </div>
                        <div className="WAW-grid-item-image">
                            <img className="JoinUs" src={joinUsImage} alt="Join us at Stafly and develop the Staflyapp" width="2088" height="956"/>
                        </div>
                    </div>
                </div>
            </div>
            <div className="OpenPositionsDiv">
                <h3 className="OpenPositions"><span className="colored-text2">OPEN POSITIONS</span></h3>
            </div>
            <div className="SecondContainer">
                <JobListing
                    title="C# & .NET DEVELOPER (INTERNSHIP)"
                    backgroundImage={internshipImage}
                    skills={[
                        "Driven and goal-oriented",
                        "Fluent in Swedish and English",
                    ]}
                    meritorious={[
                        "Interested in health & fitness",
                        "Experience with C# or .NET MAUI"
                    ]}
                    responsibilities={[
                        "Back- and/or Frontend development",
                        "Database integration",
                        "Working with authentication",
                        "Algorithm development",
                    ]}
                    workloadImage={workload50100}
                    link={internshipLink}
                />
                <JobListing
                    title="FRONTEND DEVELOPER"
                    backgroundImage={frontendImage}
                    skills={[
                        ".NET MAUI experience",
                        "Creatively inclined",
                        "Driven and goal-oriented",
                        "A self-starter",
                    ]}
                    meritorious={[
                        "Interested in health & fitness",
                        "Experience with C#"
                    ]}
                    responsibilities={[
                        "Frontend in .NET MAUI",
                        "Implement FIGMA mockups",
                        "XAML development",
                        "Some backend development",
                        "UI/UX Design",
                    ]}
                    workloadImage={workload2550}
                    link={frontendLink}
                />
                <JobListing
                    title="BACKEND DEVELOPER"
                    backgroundImage={codePicture}
                    skills={[
                        "C# experience",
                        "Driven and goal-oriented",
                        "Excellent analytical skills",
                    ]}
                    meritorious={[
                        "Interested in health & fitness",
                        "Experience with .NET MAUI"
                    ]}
                    responsibilities={[
                        "Backend development",
                        "Database integration",
                        "Working with APIs",
                        "Algorithm development",
                        "C# development",
                    ]}
                    workloadImage={workload2550}
                    link={backendLink}
                />
                <JobListing
                    title="SENIOR DEVELOPER"
                    backgroundImage={managerImage}
                    skills={[
                        "C#: 5+ years experience (required)",
                        "Driven and goal-oriented",
                        "Excellent analytical skills",
                    ]}
                    meritorious={[
                        "Interested in health & fitness",
                        
                        ".NET MAUI experience",
                    ]}
                    responsibilities={[
                        "Backend development",
                        "Working with APIs and databases",
                        "Algorithm development",
                        "C# development",
                        "Optimize and refine existing code and processes",
                        "Quality control",
                    ]}
                    workloadImage={workload2550}
                    link={technichalLeadLink}
                />
            </div>
        </div>
    );
}

function JobListing({ title, backgroundImage, skills, meritorious, responsibilities, workloadImage, link }) {
    return (
        <div className="WAW-grid-container2">
            <div className="WAW-grid-container2-item1" style={{ backgroundImage: `url(${backgroundImage})` }}>
                <div className="WAW-grid-container2-item1-overlay">
                    <h4 className="DevH2">
                        <span className="colored-text2">{title.split(' ')[0]}</span> <span className="white-text2">{title.split(' ').slice(1).join(' ')}</span>
                    </h4>
                </div>
            </div>
            <div className="WAW-grid-container2-item2">
                <img className="WorkLoadImages" src={workloadImage} alt="Workload of the position" width="3128" height="160" />
            </div>

            <div className="WAW-grid-container2-item3">
                <ul>
                    <h5>PREFERRED SKILLS</h5>
                    {skills.map(skill => (
                        <li key={skill}>{skill}</li>
                    ))}
                    <h5>MERITORIOUS</h5>
                    {meritorious.map(item => (
                        <li key={item}>{item}</li>
                    ))}
                </ul>
            </div>
            <div className="WAW-grid-container2-item4">
                <ul>
                    <h5>RESPONSIBILITIES</h5>
                    {responsibilities.map(responsibility => (
                        <li key={responsibility}>{responsibility}</li>
                    ))}
                </ul>
            </div>
            <button className="ApplHereButton" onClick={() => window.location.href = link}>READ MORE</button>
        </div>
    );
}

export default WorkAtWelleo;